var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"develop"},[_c('div',{staticClass:"developTitle"},[_c('h2',[_vm._v(_vm._s(_vm.developTitle))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.developDescription)}})]),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/history/history.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }